/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbUniteActiviteDto } from './FcbUniteActiviteDto';
import {
    FcbUniteActiviteDtoFromJSON,
    FcbUniteActiviteDtoFromJSONTyped,
    FcbUniteActiviteDtoToJSON,
} from './FcbUniteActiviteDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbUniteActiviteDtoPaginatedResults
 */
export interface FcbUniteActiviteDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbUniteActiviteDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbUniteActiviteDto>}
     * @memberof FcbUniteActiviteDtoPaginatedResults
     */
    results?: Array<FcbUniteActiviteDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbUniteActiviteDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbUniteActiviteDtoPaginatedResults interface.
 */
export function instanceOfFcbUniteActiviteDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbUniteActiviteDtoPaginatedResultsFromJSON(json: any): FcbUniteActiviteDtoPaginatedResults {
    return FcbUniteActiviteDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbUniteActiviteDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbUniteActiviteDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbUniteActiviteDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbUniteActiviteDtoPaginatedResultsToJSON(value?: FcbUniteActiviteDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbUniteActiviteDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

